import { createFileRoute } from "@tanstack/react-router";
import { CommCenter } from "@/components/comm/comm-center";

export const Route = createFileRoute("/learner/comms")({ component: () => <CommCenter role="learner" /> });
